import { WorkerUrls } from ".";

import NetworkEventDbSearchWebWorkerUrl from './NetworkEventDbSearchWebWorker?worker&url'
import PoolWorkerUrl from './PoolWorker?worker&url'

export const getWorkerUrlsInsideVite = (): WorkerUrls => ({
	NetworkEventDbSearchWebWorkerUrl,
	PoolWorkerUrl,
});
